import { useDataValue } from 'Simple/Data.js'
import useStableValue from 'Logic/useStableValue.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let search_term = useStableValue(
    useDataValue({
      viewPath: props.viewPath,
      context: 'tags_picker',
      path: 'search_term',
    })
  )

  let task_id = useDataValue({
    context: 'task',
    path: 'id',
    viewPath: props.viewPath,
  })

  let task_tags = useDataValue({
    context: 'task',
    path: 'task_tags',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      or: [
        { name: { _ilike: `%${search_term || ''}%` } },
        ...(!search_term && task_tags.length
          ? [{ id: { _in: task_tags.map(({ tag }) => tag.id) } }]
          : []),
      ],
    },
    pause: !task_id,
  }
}
